export default __webpack_public_path__ + "static/media/marke_4.27c3914d.png";